<template>
  <ion-fab :vertical="vertical" :horizontal="horizontal" slot="fixed">
    <div
      @click="openZalo"
      class="ion-activatable support-button bg"
    >
      <ion-img
        :src="require('../images/zalo-icon-circle-1.png')"
      ></ion-img>
      <ion-ripple-effect></ion-ripple-effect>
    </div>
  </ion-fab>
</template>

<style scoped>
  .support-button {
    overflow: hidden;
    position: relative;
    border: 1px solid transparent;
    border-radius: 50%;
    width: 56px;
    height: 56px;
  }

  .support-button.bg {
    background-color:#fff;
    border: 1px solid #eee;
  }

  .fake-button {
    white-space: nowrap;
    font-size: 13px;
    text-decoration: none;
    background-color: rgb(56, 128, 255);
    color: #fff;
    margin: 2px;
    padding: 0 12px;
    height: 27px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
  }
</style>

<script>
  import {
    IonRippleEffect,
    IonFab,
    IonImg,
  } from '@ionic/vue';
  import { defineComponent } from 'vue';
  import {
    callSharp,
    closeSharp,
  } from 'ionicons/icons';
  import { Plugins } from '@capacitor/core';


  export default defineComponent({
    name: 'SupportButton',
    components: {
      IonRippleEffect,
      IonFab,
      IonImg,
    },
    data() {
      return {
        showSupport: false,
      }
    },
    props: {
      showBg: {
        type: Boolean,
        default: false
      },
      hlSide: {
        type: String,
        default: "top"
      },
      zlSide: {
        type: String,
        default: "end"
      },
      horizontal: {
        type: String,
        default: "start",
      },
      vertical: {
        type: String,
        default: "bottom",
      }
    },
    methods: {
      async callHotline() {
        this.toggleSupport(false);
      },
      async openZalo() {
        this.toggleSupport(false);
        const { Browser } = Plugins;
        await Browser.open({
          url: 'http://zalo.me/4312370009698740451'
        });
      },
      toggleSupport(val) {
        setTimeout(()=>{
          this.showSupport = val;
        }, val ? 200 : 10);
      },
    },
    setup() {
      return {
        callSharp,
        closeSharp,
      }
    },
  })
</script>
